import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { LAUNCH_CONSULTATION, LAUNCH_STARTING_POINT_KEY } from '@/data/launch';
import { SlashMark } from '../AmdenMark';
import { Reveal } from '../Reveal';

const ACCENT = '#4225C4';

export const ConsultationPanel = () => {
  const startingPoint =
    typeof window !== 'undefined' ? window.sessionStorage.getItem(LAUNCH_STARTING_POINT_KEY) : null;
  const href = `${LAUNCH_CONSULTATION.baseHref}${startingPoint ? `&startingPoint=${startingPoint}` : ''}#solution-finder`;

  return (
    <section aria-labelledby="consultation-heading" data-testid="consultation-panel" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative mx-auto max-w-4xl overflow-hidden rounded-2xl border border-slate-200 bg-mist px-8 py-14 text-center sm:px-12">
            <SlashMark
              className="pointer-events-none absolute -right-10 -top-10 h-44 w-44 opacity-[0.05]"
              bar="#0B1729"
              dot="#4225C4"
            />
            <h2 id="consultation-heading" className="text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
              {LAUNCH_CONSULTATION.heading}
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
              {LAUNCH_CONSULTATION.copy}
            </p>
            <Link
              to={href}
              data-testid="consultation-start-btn"
              className="group mt-8 inline-flex items-center gap-2 rounded-md bg-navy-900 px-7 py-4 text-base font-bold text-white transition-colors hover:bg-navy-700"
            >
              {LAUNCH_CONSULTATION.button}
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
